import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from '@/shared/components/ProtectedRoute';
import GuestRoute from '@/shared/components/GuestRoute';
import Index from '@/domains/Index';
import SLAPage from '@/app/legal/SLAPage';
import UserGuidePage from '@/app/legal/user-guide/UserGuidePage';
import LoginPage from '@/app/auth/LoginPage';
import ForgotPasswordPage from '@/app/auth/ForgotPasswordPage';
import ResetPasswordPage from '@/app/auth/ResetPasswordPage';
import VerifyOTPPage from '@/app/auth/VerifyOTPPage';
import { CatchAllRoute } from '@/app/shared/CatchAllRoute';
import { ROUTES } from '@/config/routeConfig';
import CustomerDetailsPage from '@/domains/customers/pages/CustomerDetailsPage';
import CustomerServiceLineDetailsPage from '@/domains/customers/pages/CustomerServiceLineDetailsPage';

/**
 * Customer (end user) shell: auth + customer-scoped navigation.
 * Users with `CUSTOMER` role are routed here via `AppShellGate`.
 */
export function CustomerRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path={ROUTES.LOGIN} element={<GuestRoute><LoginPage /></GuestRoute>} />
      <Route path={ROUTES.FORGOT_PASSWORD} element={<GuestRoute><ForgotPasswordPage /></GuestRoute>} />
      <Route path={ROUTES.RESET_PASSWORD} element={<GuestRoute><ResetPasswordPage /></GuestRoute>} />
      <Route path={ROUTES.VERIFY} element={<GuestRoute><VerifyOTPPage /></GuestRoute>} />
      <Route
        path={ROUTES.CUSTOMER_SERVICE_LINE_DETAILS}
        element={
          <ProtectedRoute>
            <CustomerServiceLineDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CUSTOMER_DETAILS_TAB.replace(':tabSlug', ':tabSlug?')}
        element={
          <ProtectedRoute>
            <CustomerDetailsPage shouldAllowAccountChange={true} />
          </ProtectedRoute>
        }
      />
      <Route path={ROUTES.SLA} element={
        <ProtectedRoute>
          <SLAPage />
        </ProtectedRoute>
      }
      />
      <Route path={ROUTES.USER_GUIDE} element={
        <ProtectedRoute>
          <UserGuidePage />
        </ProtectedRoute>
      }
      />
      <Route path="*" element={<CatchAllRoute />} />
    </Routes>
  );
}
